import(/* webpackMode: "eager" */ "/codebuild/output/src3325677575/src/website/app/global-error.tsx");
